import UIButton from 'UIComponents/button/UIButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerContainer = styled.div.withConfig({
  displayName: "UpdateFilterWithExternalOptionsNotification__BannerContainer",
  componentId: "sc-1vs7a7u-0"
})(["margin-bottom:10px;"]);
const UpdateFilterWithExternalOptionsNotification = ({
  onUpdateClick,
  canFilterBeConverted
}) => {
  return /*#__PURE__*/_jsx(BannerContainer, {
    children: /*#__PURE__*/_jsxs(UIAlert, {
      className: "p-x-2",
      "data-test-id": "update-filter-with-external-options-notification",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.externalOptionsFilterUpdate.title"
      }),
      type: "tip",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.externalOptionsFilterUpdate.text"
      }), !canFilterBeConverted && /*#__PURE__*/_jsx(UIAlert, {
        className: "m-top-2 p-x-2",
        "data-test-id": "update-filter-with-external-options-warning",
        type: "warning",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.externalOptionsFilterUpdate.warning"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "update-filter-with-external-options-button",
          disabled: !canFilterBeConverted,
          onClick: onUpdateClick,
          responsive: false,
          style: {
            paddingLeft: 0
          },
          use: "transparent",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.externalOptionsFilterUpdate.action"
          })
        })
      })]
    })
  });
};
export default UpdateFilterWithExternalOptionsNotification;